import confetti from "canvas-confetti";

// Gold "Elite Mastered" celebration burst.
export function eliteConfetti() {
  const gold = ["#F5C518", "#FFE68A", "#D4AF37", "#C41E24", "#ffffff"];
  confetti({ particleCount: 140, spread: 95, startVelocity: 45, origin: { y: 0.6 }, colors: gold, scalar: 1.2 });
  const end = Date.now() + 1400;
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors: gold });
    confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors: gold });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
